import React from "react";
import Spinner from "../ui/spinner";
import { TekkrLogo } from "./tekkr/tekkr-logo";

export function FullScreenLoader() {
    return (
        <div
            className={
                "fixed bottom-0 left-0 right-0 top-0 flex flex-col items-center justify-center gap-4 duration-700 animate-in fade-in-0"
            }
        >
            <TekkrLogo />
            <Spinner />
        </div>
    );
}
